import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { AdapterDayjs, LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs";
import { GLOBAL_URL } from "../../../API/global";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { FormControl } from "@mui/material";
import { handleKeyDown, validatePdf } from "../../Helper";

const CbfcCertification = ({
  formData,
  setFormData,
  errors,
  setCbfcErrors,
}) => {
  // const [dateOfCbfcCertificate, setDateOfCbfcCertificate] = useState(null);
  // const [dateOfCompletionProduction, setDateOfCompletionProduction] = useState(null);

  // useEffect(() => {
  //   // Show modal when component mounts
  //   console.log("2st use effect")
  //   setPreDateData();

  // }, []);

  // const setPreDateData = () => {
  //   console.log({date_of_cbfc_certificate:formData.date_of_cbfc_certificate})
  //   if( formData.date_of_cbfc_certificate){
  //     console.log("data fetch")
  //     setDateOfCbfcCertificate(dayjs( formData.date_of_cbfc_certificate ));
  //   };
  //   if( formData.date_of_completion_production){
  //     setDateOfCompletionProduction(dayjs( formData.date_of_completion_production ));
  //   };
  // }

  const [CbfcOrUncensoresd, setCbfcOrUncensoresd] = React.useState(false);

  const handleCbfcOrUncensoresdChange = (e) => {
    const { name, value } = e.target;
    const parsedValue = parseInt(value, 10); // Ensure the value is parsed as an integer
    const errorsCopy = { ...errors }; // Create a copy of the current errors

    // console.log(parsedValue);

    if (parsedValue === 1) {
      setCbfcOrUncensoresd(1);
    } else {
      // console.log(parsedValue);
      setCbfcOrUncensoresd(2);
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: parsedValue,
    }));

    errorsCopy[name] = ""; // Clear the error for this specific field
    setCbfcErrors(errorsCopy); // Update the error state with the cleared error
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    errors[name] = "";
    setCbfcErrors(errors);
  };

  // const [selectedFile, setSelectedFile] = useState(null);

  // const [country, setCountry] = React.useState('');

  // const [selectedDate, setSelectedDate] = React.useState(null);

  // const handleDateChange = (date) => {
  //   setSelectedDate(date);
  // };

  const [selectedCbfcFile, setSelectedCbfcFile] = useState();
  const [formErrors, setFormErrors] = useState({});

  const handleFileCbfcChange = (event) => {
    const file = event.target.files[0];
    let newErrors = { ...errors }; // Copy the existing errors
    const selectedFile = event.target.files[0];
    const validateState = validatePdf(selectedFile);
    if (!validateState["status"]) {
      setCbfcErrors({
        file_cbfc_certificate: validateState.message,
      });
    } else {
      setSelectedCbfcFile(file);
      setFormData((prevState) => ({
        ...prevState,
        file_cbfc_certificate: file,
        is_file_cbfc_certificate: 1,
      }));
      setCbfcErrors({
        file_cbfc_certificate: "",
      });
    }
  };

  const [selectedAttachCopyFile, setSelectedAttachCopyFile] = useState(null);

  const handleFileAttachCopyChange = (event) => {
    const fileclause = event.target.files[0];
    let newErrors = { ...errors }; // Copy the existing errors

    const selectedFile = event.target.files[0];
    const validateState = validatePdf(selectedFile);
    if (!validateState["status"]) {
      setCbfcErrors({
        declaration_clause_file: validateState.message,
      });
    } else {
      setSelectedAttachCopyFile(fileclause);
      setFormData((prevState) => ({
        ...prevState,
        declaration_clause_file: fileclause,
        is_declaration_clause_file: 1,
      }));
      setCbfcErrors({
        declaration_clause_file: "",
      });
    }
  };

  const handleChangeDateOfCompletionProduction = (e) => {
    // Format the date to 'DD/MM/YYYY'
    const formattedDate = e.format("DD/MM/YYYY");

    // Update form data with the formatted date
    setFormData((prevData) => ({
      ...prevData,
      date_of_cbfc_certificate: dayjs(formattedDate, "DD/MM/YYYY"),
    }));

    // Clear the error message for date_of_cbfc_certificate
    setCbfcErrors((prevErrors) => ({
      ...prevErrors,
      date_of_cbfc_certificate: "",
    }));
  };
  const handleChangeDateOfCbfcCertificate = (e) => {
    // console.log(e);
    const formattedDate = e.format("DD/MM/YYYY");
    // console.log(formattedDate);
    setFormData((prevData) => ({
      ...prevData,
      date_of_completion_production: dayjs(formattedDate, "DD/MM/YYYY"),
    }));

    // Clear the error message for date_of_cbfc_certificate
    setCbfcErrors((prevErrors) => ({
      ...prevErrors,
      date_of_completion_production: "",
    }));
  };

  return (
    <>
      <h4>
        9. Details of CBFC Certification/ Completion of the Production
        <span className="text-danger">*</span>
      </h4>
      <form>
        <div className="row">
          <div className="col-sm-12 col-lg-6 mt-4">
            <h6>Whether the film is certified by CBFC ?</h6>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_is_certified_by_cbfc_or_uncensored"
                id="film_is_certified_by_cbfc_or_uncensored_yes"
                value="1"
                checked={formData.film_is_certified_by_cbfc_or_uncensored == 1}
                onChange={handleCbfcOrUncensoresdChange}
              />
              <label
                className="form-check-label"
                htmlFor="film_is_certified_by_cbfc_or_uncensored_yes"
              >
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="film_is_certified_by_cbfc_or_uncensored"
                id="film_is_certified_by_cbfc_or_uncensored_no"
                value="2"
                checked={formData.film_is_certified_by_cbfc_or_uncensored == 2}
                onChange={handleCbfcOrUncensoresdChange}
              />
              <label
                className="form-check-label"
                htmlFor="film_is_certified_by_cbfc_or_uncensored_no"
              >
                No
              </label>
            </div>
          </div>
          {errors.film_is_certified_by_cbfc_or_uncensored && (
            <p className="text-danger">
              {errors.film_is_certified_by_cbfc_or_uncensored}
            </p>
          )}
        </div>

        {formData.film_is_certified_by_cbfc_or_uncensored == 1 ? (
          <>
            <div className="row">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Box style={{ width: "100%" }}>
                    <FormControl>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <DatePicker
                            label="(a) Date of CBFC certificate"
                            // placeholder="Date of CBFC certificate"
                            onChange={handleChangeDateOfCompletionProduction}
                            name="date_of_cbfc_certificate"
                            value={formData.date_of_cbfc_certificate}
                            minDate={dayjs("2025-08-01")}
                            maxDate={dayjs("2026-07-31")}
                            format="DD/MM/YYYY"
                            placeholderText="DD/MM/YYYY"
                            slotProps={{
                              textField: {
                                InputProps: { readOnly: true },
                                readOnly: true,
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </FormControl>
                  </Box>
                  {errors.date_of_cbfc_certificate && (
                    <p className="text-danger">
                      {errors.date_of_cbfc_certificate}
                    </p>
                  )}
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  lg={6}
                  md={6}
                  mt={2}
                  mx={0}
                  className="m-0"
                >
                  <Box>
                    <TextField
                      fullWidth
                      label="(b) Certification No"
                      // type="number"
                      type="text"
                      // InputProps={{
                      //   style: {
                      //     border: "1px solid #1c5768",
                      //     borderRadius: "5px",
                      //   },
                      // }}

                      className="input_border"
                      name="certificate_no"
                      // helperText="Certification No"
                      value={formData.certificate_no}
                      onChange={handleChange}
                      // onKeyDown={handleKeyDown}
                    />
                    {errors.certificate_no && (
                      <p className="text-danger">{errors.certificate_no}</p>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <Box>
                    <input
                      type="file"
                      // accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,image/*"
                      accept=".pdf"
                      onChange={handleFileCbfcChange}
                      style={{ display: "none", width: "100%", height: "10px" }}
                      id="fileInput"
                      name="file_cbfc_certificate"
                      // value={formData.file_cbfc_certificate}
                    />
                    <label htmlFor="fileInput" style={{ width: "100%" }}>
                      <TextField
                        variant="outlined"
                        // placeholder="(c) Attach Copy Of CBFC Certificate"
                        label="(c) Attach copy of CBFC certificate (.pdf)"
                        value={selectedCbfcFile ? selectedCbfcFile.name : ""}
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() =>
                                  document.getElementById("fileInput").click()
                                }
                                edge="end"
                              >
                                <AttachFileIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                          style: {
                            // border: "1px solid #1c5768",
                            borderRadius: "5px",
                            height: "54px",
                          },
                        }}
                        fullWidth
                      />
                      {formErrors.file_cbfc_certificate && (
                        <p className="text-danger">
                          {formErrors.file_cbfc_certificate}
                        </p>
                      )}
                      {!formErrors.file_cbfc_certificate &&
                        errors.file_cbfc_certificate && (
                          <p className="text-danger">
                            {errors.file_cbfc_certificate}
                          </p>
                        )}
                    </label>
                  </Box>
                  {/* {!(formData?.documentData?.[4]) ? <></> : (
                      <div>
                        <span className="Attach_Photo_ID">
                          <a href={`${GLOBAL_URL}downloadfile/IP/${formData.id}/${formData?.documentData?.[4].file}`}>{formData?.documentData?.[4].name}</a>
                        </span>
                      </div>
                    )} */}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  lg={6}
                  md={6}
                  mt={2}
                  mx={0}
                  className="m-0"
                ></Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  {!formData?.documentData?.[4] ? (
                    <></>
                  ) : (
                    <div>
                      <span className="Attach_Photo_ID">
                        <a
                          href={`${GLOBAL_URL}downloadfile/IP/${formData.id}/${formData?.documentData?.[4].file}`}
                        >
                          {formData?.documentData?.[4].name}
                        </a>
                      </span>
                    </div>
                  )}
                </Grid>
              </Grid>
            </div>
          </>
        ) : formData.film_is_certified_by_cbfc_or_uncensored == 2 ? (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} mt={2}>
                <Box style={{ width: "100%" }}>
                  <FormControl
                  // sx={{
                  //   width: {
                  //     xs: '100%',
                  //     sm: '100%',
                  //     md: '100%',
                  //     lg: '100%',
                  //   }
                  // }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker
                          label="(a) Date of Completion of Production"
                          // placeholder="Date of Completion of Production"
                          name="date_of_completion_production"
                          value={formData.date_of_completion_production}
                          onChange={handleChangeDateOfCbfcCertificate}
                          minDate={dayjs("2025-08-01")}
                          maxDate={dayjs("2026-07-31")}
                          format="DD/MM/YYYY"
                          placeholderText="DD/MM/YYYY"
                          slotProps={{
                            textField: {
                              InputProps: { readOnly: true },
                              readOnly: true,
                            },
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </FormControl>
                </Box>
                {errors.date_of_completion_production && (
                  <p className="text-danger">
                    {errors.date_of_completion_production}
                  </p>
                )}
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={12} mt={2} mx={2}>
                <Box>
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,image/*"
                    onChange={handleFileAttachCopyChange}
                    style={{ display: "none", width: "100%" }}
                    id="fileInput"
                    name="declaration_clause_file"
                  />
                  <label
                    htmlFor="fileInput"
                    style={{ width: "100%", height: "100%" }}
                  >
                    <TextField
                      variant="outlined"
                      // placeholder="(b) Attach Copy Of Declaration As per Clause (7.2(C))"
                      label="(b) Attach Copy Of Declaration As per Clause (8.2(C))"
                      value={
                        selectedAttachCopyFile
                          ? selectedAttachCopyFile.name
                          : ""
                      }
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                document.getElementById("fileInput").click()
                              }
                              edge="end"
                            >
                              <AttachFileIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                        style: {
                          // border: "1px solid #1c5768",
                          borderRadius: "5px",
                          height: "54px",
                        },
                      }}
                      fullWidth
                    />
                    {formErrors.declaration_clause_file && (
                      <p className="text-danger">
                        {formErrors.declaration_clause_file}
                      </p>
                    )}
                    {!formErrors.declaration_clause_file &&
                      errors.declaration_clause_file && (
                        <p className="text-danger">
                          {errors.declaration_clause_file}
                        </p>
                      )}
                  </label>
                  {!formData?.documentData?.[3] ? (
                    <></>
                  ) : (
                    <div>
                      <span className="Attach_Photo_ID">
                        <a
                          href={`${GLOBAL_URL}downloadfile/IP/${formData.id}/${formData?.documentData?.[3].file}`}
                        >
                          {formData?.documentData?.[3].name}
                        </a>
                      </span>
                    </div>
                  )}
                </Box>
              </Grid>
            </Grid>
          </>
        ) : (
          <></>
        )}
      </form>
    </>
  );
};

export default CbfcCertification;
